import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetProductCategoryV1ProductCategoriesCategoryIdGetData,
  type GetProductCategoryV1ProductCategoriesCategoryIdGetError,
  type GetProductCategoryV1ProductCategoriesCategoryIdGetResponse,
  getProductCategoryV1ProductCategoriesCategoryIdGet,
} from '../../generated';

export type GetProductCategoryQueryVariables = GetProductCategoryV1ProductCategoriesCategoryIdGetData['path'];

export type GetProductCategoryQuery = GetProductCategoryV1ProductCategoriesCategoryIdGetResponse;

export const useGetProductCategoryQuery = <
  TData = GetProductCategoryQuery,
  TError = GetProductCategoryV1ProductCategoriesCategoryIdGetError,
>(
  { category_id }: GetProductCategoryQueryVariables,
  options?: Omit<UseQueryOptions<GetProductCategoryQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetProductCategoryQuery, TError, TData>({
    queryKey: ['GetProductCategory', { category_id }],
    queryFn: async () => {
      const { data } = await getProductCategoryV1ProductCategoriesCategoryIdGet({
        path: { category_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetProductCategoryQuery.getKey = ({ category_id }: GetProductCategoryQueryVariables) => [
  'GetProductCategory',
  { category_id },
];

useGetProductCategoryQuery.fetcher = (
  { category_id }: GetProductCategoryQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getProductCategoryV1ProductCategoriesCategoryIdGet({
      path: { category_id },
      throwOnError: true,
    });
    return data;
  };
};
